<template>
  <v-container text-xs-center>
    <div class="elevation-5">
      <BaseToolbar toolbarTitle="Group's">
        <template v-slot:toolbarBtn>
          <!-- Search Input -->
          <v-text-field
            v-if="searchVisible"
            v-model="search"
            label="Search Group"
            single-line
            hide-details
            filled
            rounded
            dense
            style="margin-right: 8px; max-width: 130px"
          ></v-text-field>
          <!-- Expandable Search Icon -->
          <v-icon
            color="primary"
            @click="
              searchVisible = !searchVisible;
              search = '';
            "
            style="cursor: pointer"
          >
            search
          </v-icon>
          <v-divider vertical style="margin: 0 8px"></v-divider>
          <!-- Search Input -->
          <v-dialog
            v-model="dialogFilter"
            :retain-focus="false"
            max-width="700px"
            persistent
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" dark v-on="on" v-bind="attrs">
                tune
              </v-icon>
              <!-- <span>{{ "Settings" }} </span> -->
            </template>

            <v-card>
              <!-- <v-card-title>
                <span class="headline">Athlete's Settings</span>
              </v-card-title> -->
              <v-card-text>
                <span class="headline">Group's Settings</span>
                <v-divider style="margin: 8px"></v-divider>
                <v-select
                  v-model="competitiveFilter"
                  :items="filterOptions"
                  label="Filter by Team Type"
                  class="mt-1"
                  outlined
                  hide-details
                  @change="filterGroupData"
                />
                <v-divider style="margin: 12px"></v-divider>
                <v-select
                  v-model="status_selected"
                  :items="catValueListArray('athlete_status')"
                  v-if="isAdmin()"
                  :menu-props="{ maxHeight: '400' }"
                  label="Days Status Filter"
                  multiple
                  dark
                  outlined
                  dense
                  hide-details
                  clearable
                  class="light-blue darken-4 select_tab_bar"
                ></v-select>
                <v-divider style="margin: 8px"></v-divider>
                <span class="headline">System Settings</span>
                <v-divider style="margin: 8px"></v-divider>
                <v-icon
                  :color="tableMobile == 0 ? 'grey' : 'primary'"
                  small
                  class="mr-2"
                  @click="tableMobile = tableMobile == 0 ? 600 : 0"
                >
                  display_settings
                </v-icon>
                <span>{{ "Mobile Display" }} </span>
              </v-card-text>

              <v-card-actions>
                <v-btn color="primary" @click="dialogFilter = false"
                  >Close</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-divider vertical style="margin: 0 8px"></v-divider>
          <v-dialog
            v-model="dialog"
            :retain-focus="false"
            max-width="700px"
            persistent
          >
            <template v-slot:activator="{ on, attrs }">
              <!-- <span>{{ " Add Athlete" }} </span> -->
              <v-icon color="primary" dark v-on="on" v-bind="attrs">
                group_add
              </v-icon>
            </template>
          </v-dialog>
        </template>
      </BaseToolbar>
    </div>

    <v-data-table
      tableStyle="min-width: 50rem"
      :headers="headers"
      :items="sortedGroupData"
      :search="search"
      :loading="loading"
      class="elevation-5"
      loading-text="Loading... Please wait"
      hide-default-footer
      :items-per-page="-1"
      :item-class="getItemClass"
      item-key="node.teamId"
      :expanded.sync="expanded"
      show-expand
    >
      <!-- Expandable row template -->

      <!-- <template v-slot:item.data-table-expand="{ expand, isExpanded }">
        <v-icon @click="expand(!isExpanded)">
          {{ isExpanded ? "fas fa-chevron-up" : "fas fa-chevron-down" }}
        </v-icon>
      </template> -->

      <!-- Expanded row content -->
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pa-5">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-data-table
                tableStyle="min-width: 5rem"
                dense
                hide-default-footer
                :headers="getSubTableHeaders(item.node.swimmerCounts)"
                :items="[item.node.swimmerCounts]"
              >
              </v-data-table>
            </v-expansion-panel>
            <v-expansion-panel>
              <WorkoutSchedule
                :group-id="Number(item.node.teamId)"
                :swimmer-count="item.node.swimmerCounts"
              />
            </v-expansion-panel>
          </v-expansion-panels>
        </td>
      </template>

      <template #footer>
        <v-btn color="primary" class="no-print" @click="printPage"
          >Print Table</v-btn
        >
        <v-btn
          color="primary"
          :disabled="isSendGroupEmail"
          @click="sendGroupEmail"
          :title="isSendGroupEmail ? 'Test' : ''"
          >{{
            isSendGroupEmail ? "Select Groups for Email" : "Send Group(s) Email"
          }}</v-btn
        >
      </template>
      <template v-slot:body.append>
        <tr class="total-row">
          <td colspan="5" class="text-right"></td>
          <td class="text-center">
            <strong>{{ totalActiveAthletes }}</strong>
          </td>
          <td class="text-center">
            <strong>{{ totalMaxAthletes }}</strong>
          </td>
          <td class="text-center">
            <strong>{{ totalMaxAthletes - totalActiveAthletes }}</strong>
          </td>
          <td class="text-center">
            <strong>{{ totalLeads }}</strong>
          </td>
          <td class="text-center">
            <strong>{{ totalReconnectLeads }}</strong>
          </td>

          <td class="text-center">
            <strong>{{ totalMalevsFemale }}</strong>
          </td>
          <!-- <td colspan="4"></td> -->
          <!-- Fill the remaining cells -->
        </tr>
      </template>
      <!-- Clickable Team Name -->
      <template v-slot:[`item.node.teamName`]="{ item }">
        <a
          href="#"
          @click.prevent="goToTeam($route.params.club, item.node.teamName)"
          class="team-link"
        >
          {{ item.node.teamName + " (" + item.node.teamId + ")" }}
        </a>
      </template>

      <!-- Clickable Leads Value with multiple statuses -->
      <template v-slot:[`item.node.leadsCount`]="{ item }">
        <a
          href="#"
          @click.prevent="
            goToAthletes($route.params.club, item.node.teamName, [
              'deposit',
              'tryout',
              'qualified',
              'confirmed',
            ])
          "
          class="leads-link"
        >
          {{ item.node.leadsCount }}
        </a>
      </template>
      <template v-slot:[`item.node.reconnectLeadsCount`]="{ item }">
        <a
          href="#"
          @click.prevent="
            goToAthletes($route.params.club, item.node.teamName, [
              'waitlist',
              'reconnect',
            ])
          "
          class="leads-link"
        >
          {{ item.node.reconnectLeadsCount }}
        </a>
      </template>

      <!-- Scoped slot for the Team Description column -->
      <template v-slot:[`item.node.teamDescription`]="{ item }">
        <span>{{ truncateText(item.node.teamDescription) }}</span>
      </template>
      <!-- Scoped slot for the Commitment Requirements column -->
      <template v-slot:[`item.node.commitmentRequirements`]="{ item }">
        <span>{{ truncateText(item.node.commitmentRequirements) }}</span>
      </template>

      <template v-slot:[`item.availableSpots`]="{ item }">
        <span>{{ item.availableSpots }}</span>
      </template>
      <!-- Render Male vs Female athletes count in the table -->
      <template v-slot:[`item.maleVsFemale`]="{ item }">
        <span>{{ item.maleVsFemale }}</span>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <div class="action-container">
          <v-menu offset-y open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <v-btn x-small color="primary" dark v-bind="attrs" v-on="on">
                <v-icon small>more_vert</v-icon>
              </v-btn>
            </template>
            <!-- Menu content (will only be visible when the menu is active) -->
            <v-list>
              <!-- Edit Action -->
              <v-list-item @click="editItem(item.node)">
                <v-list-item-icon>
                  <v-icon>edit</v-icon>
                  <!-- Edit icon -->
                </v-list-item-icon>
                <v-list-item-title>Edit</v-list-item-title>
              </v-list-item>
              <!-- <v-list-item @click="sendGroupEmail(item.node)">
                <v-list-item-icon>
                  <v-icon>email</v-icon>                  
                </v-list-item-icon>
                <v-list-item-title>Email </v-list-item-title>
              </v-list-item> -->
              <!-- Delete Action -->
              <v-list-item @click="deleteItem(item.node)">
                <v-list-item-icon>
                  <v-icon>delete</v-icon>
                  <!-- Delete icon -->
                </v-list-item-icon>
                <v-list-item-title>Delete</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-checkbox
            class="small-checkbox"
            :input-value="isSelected(item.node.teamId)"
            @change="toggleSelection(item.node.teamId)"
            hide-details
          ></v-checkbox>
        </div>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
    <!-- Total Row Below the Table
    <v-row class="mt-4 justify-end">
      <v-col cols="12" sm="4" class="text-right total-row">
        <v-card outlined>
          <v-card-text>
            <strong>Total Active Athletes: {{ totalActiveAthletes }}</strong>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row> -->
    <!-- Total Max Athletes -->
    <!-- <v-row class="mt-2 justify-end">
      <v-col cols="12" sm="4" class="text-right">
        <v-card outlined>
          <v-card-text>
            <strong>Total Max Athletes: {{ totalMaxAthletes }}</strong>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row> -->
    <v-dialog
      v-model="dialog"
      :retain-focus="false"
      max-width="1200px"
      persistent
    >
      <!-- <template v-slot:activator="{ on }">
                <v-btn color="primary" dark v-on="on">New Item</v-btn>
              </template> -->
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.teamName"
                  label="Team Name"
                  :rules="nameRules"
                  :counter="50"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-select
                  class="hidden-xs-only"
                  v-model="editedItem.sportType"
                  :items="sportTypeList()"
                  label="Sport"
                  :rules="requiredRule"
                  item-value="node.valName"
                  item-text="node.valName"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-switch
                  color="secondary"
                  v-model="editItem.visibility"
                  label="Visibility"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.logo"
                  label="Logo"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.orderOnUi"
                  label="OrderOnUI"
                ></v-text-field>
              </v-flex>
              <!-- Swimmers per Group -->
              <v-flex xs12 sm6 md4>
                <v-text-field
                  type="number"
                  v-model="editedItem.maxAthletes"
                  label="Max Number of Athletes"
                ></v-text-field>
              </v-flex>
              <!-- Ratio -->
              <v-flex xs12 sm6 md4>
                <v-text-field
                  type="number"
                  v-model="editedItem.studentCoachRatio"
                  label="Student to Coach Ratio"
                ></v-text-field>
              </v-flex>
              <!-- Competitive Flag -->
              <v-flex xs12 sm6 md4>
                <v-switch
                  v-model="editedItem.competitiveFlag"
                  label="Competitive Flag Team"
                  inset
                ></v-switch>
              </v-flex>
              <!-- Fees: Monthly, Fundraising, Registration -->
              <v-flex xs12 sm6 md4>
                <v-text-field
                  type="number"
                  v-model="editedItem.monthlyFee"
                  label="Monthly Fee"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  type="number"
                  v-model="editedItem.fundrasingFee"
                  label="Fundraising Fee"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  type="number"
                  v-model="editedItem.registrationFee"
                  label="Registration Fee"
                ></v-text-field>
              </v-flex>

              <!-- Coach ID -->
              <v-flex xs12 sm6 md4>
                <v-text-field
                  type="number"
                  v-model="editedItem.coaches"
                  label="Coach"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.teamDescription"
                  label="Team Description"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.commitmentRequirements"
                  label="Commitment Requirements"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="editedItem.year"
                      label="Year"
                      prepend-icon="event"
                      v-on="on"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedItem.year"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="close">Cancel</v-btn>
          <v-btn :disabled="!isFormValid" color="secondary" text @click="save"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import BaseToolbar from "../../base/BaseToolbar.vue";
import { getCatValues } from "../../../mixins/getCatValues.js";
import WorkoutSchedule from "./WorkoutSchedule.vue"; // Import child component

export default {
  components: {
    BaseToolbar,
    WorkoutSchedule,
  },
  mixins: [getCatValues],
  data() {
    return {
      tableMobile: 0,
      status_selected: ["active"],
      selectedTeams: [], // Array to store selected team IDs
      selectedTab: "", // Store the selected team name
      statuses: [], // Store the statuses from query parameters
      clubId: null, // Store the clubId from route params
      competitiveFilter: "all", // Default to 'all',
      expanded: [],
      filterOptions: [
        { value: "all", text: "Show All" },
        { value: "competitive", text: "Competitive Teams" },
        { value: "non-competitive", text: "Non-Competitive Teams" },
      ],
      page: 1,
      itemsPerPage: 10,
      pageCount: 0,
      isFormValid: true,
      status: "active",
      search: "",
      searchVisible: false,
      totalAthletes: "",
      totalGroups: "",
      on: 1,
      currentDate: new Date().toISOString().substr(0, 10),
      dialog: false,
      menu: false,
      name: "Default",
      dialogFilter: false,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 50) || "Name must be less than 10 characters",
      ],
      requiredRule: [(v) => !!v || "Value is required"],
      headers: [
        {
          text: "Actions",
          value: "action",
          sortable: false,
          align: "left",
        },
        {
          text: "Team Name",
          align: "left",
          sortable: false, // Disable sorting for simplicity on total row
          value: "node.teamName",
        },
        {
          text: "Team Description",
          align: "center",
          sortable: false, // Disable sorting for simplicity on total row
          value: "node.teamDescription",
        },
        {
          text: "Commitment Requirements",
          align: "center",
          sortable: false, // Disable sorting for simplicity on total row
          value: "node.commitmentRequirements",
        },
        {
          text: "Number of Active Athletes",
          value: "node.activeAthletes.length", // Updated to show only active athletes count
          sortable: false,
          align: "center",
        },
        {
          text: "Max Number of Athletes",
          align: "center",
          sortable: false, // Disable sorting for simplicity on total row
          value: "node.maxAthletes",
        },
        {
          text: "Available Spots",
          value: "availableSpots",
          align: "center",
          sortable: true,
        },
        {
          text: "Active Leads",
          value: "node.leadsCount",
          align: "center",
          sortable: false,
        },

        {
          text: "Reconnect Leads",
          value: "node.reconnectLeadsCount",
          align: "center",
          sortable: false,
        },
        {
          text: "Male vs Female",
          value: "maleVsFemale",
          align: "center",
          sortable: false,
        },
        // {
        //   text: "Sport Type",
        //   value: "node.sportType",
        //   align: "center"
        // },
        // {
        //   text: "Order On UI",
        //   align: "center",
        //   sortable: true,
        //   value: "node.orderOnUi"
        // },
      ],
      editedIndex: -1,
      editedItem: {
        "node.teamId": "",
        "node.teamName": "",
        "node.year": 0,
        "node.toYear": 0,
        "node.visibility": 0,
        "node.sportType": 0,
        "node.orderOnUi": 100,
        "node.logo": 0,
        "node.competitiveFlag": false,
        "node.monthlyFee": 0,
        "node.fundrasingFee": 0,
        "node.registrationFee": 0,
        "node.coaches": null,
        "node.maxAthletes": 0,
        "node.studentCoachRatio": 0,
        "node.teamDescription": null,
        "node.commitmentRequirements": null,
      },
      defaultItem: {
        "node.teamId": "",
        "node.teamName": "",
        "node.year": 0,
        "node.toYear": 0,
        "node.visibility": 0,
        "node.sportType": 0,
        "node.orderOnUi": 100,
        "node.logo": 0,
        "node.competitiveFlag": false,
        "node.monthlyFee": 0,
        "node.fundrasingFee": 0,
        "node.registrationFee": 0,
        "node.coaches": null,
        "node.maxAthletes": 0,
        "node.studentCoachRatio": 0,
        "node.teamDescription": null,
        "node.commitmentRequirements": null,
      },
    };
  },
  created() {
    this.handleGetClubInfo();
    // Read the 'tab' and 'status' query parameters
    this.selectedTab = this.$route.query.tab || "Unknown Team";
    this.statuses = Array.isArray(this.$route.query.status)
      ? this.$route.query.status
      : [this.$route.query.status]; // Ensure statuses is an array

    // Read the 'clubId' from route params
    this.clubId = this.$route.params.clubId;
  },
  computed: {
    ...mapGetters(["loading", "clubInfo", "categoryValue", "user"]),
    // subTableHeaders() {
    //   // Collect unique headers from all teams while filtering out empty ones
    //   const allDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

    //   return allDays.filter((day) =>
    //     this.groupData.some((team) => team.node.swimmerCounts[day] > 0)
    //   );
    // },
    formTitle() {
      return this.editedIndex === -1 ? "New Team" : "Edit Team";
    },
    isSendGroupEmail() {
      return this.selectedTeams.length === 0;
    },
    sortedGroupData() {
      // Sort by orderOnUi in ascending order and return sorted data
      return this.filteredGroupData
        .slice()
        .sort((a, b) => a.node.orderOnUi - b.node.orderOnUi);
    },
    groupData() {
      if (this.clubInfo.edges && this.clubInfo.edges.length > 0) {
        const clubIndex = this.clubInfo.edges.findIndex(
          (elem) => elem.node.clubId == this.$route.params.club.toString()
        );

        if (clubIndex !== -1) {
          return this.clubInfo.edges[clubIndex].node.team.edges.map((team) => {
            // console.log(team.node.teamName);
            const activeAthletes = team.node.athlete.edges.filter(
              (athlete) =>
                athlete.node.status === "active" ||
                (athlete.node.status !== "inactive" &&
                  team.node.teamName.includes("TRYOUT"))
            );

            // Calculate male and female counts
            const maleCount = activeAthletes.filter(
              (athlete) => athlete.node.gender === "male"
            ).length;
            const femaleCount = activeAthletes.filter(
              (athlete) => athlete.node.gender === "female"
            ).length;
            // Calculate the count of "leads" (neither active nor inactive)
            const leadsCount = team.node.athlete.edges.filter(
              (a) =>
                a.node.status == "tryout" ||
                a.node.status == "qualified" ||
                a.node.status == "confirmed" ||
                a.node.status == "deposit"
            ).length;
            const reconnectLeadsCount = team.node.athlete.edges.filter(
              (a) => a.node.status == "reconnect" || a.node.status == "waitlist"
            ).length;
            const maxAthletes = team.node.maxAthletes; // Max number of athletes

            // ✅ FIX: Calculate `swimmerCounts` **per team** instead of using `this.sortedGroupData`
            const swimmerCounts = team.node.athlete.edges
              .filter(({ node }) => this.status_selected.includes(node.status))
              .reduce(
                (acc, { node }) => {
                  const participationDays = JSON.parse(
                    node.participationDays || "[]"
                  );
                  participationDays.forEach((day) => {
                    if (acc[day] !== undefined) acc[day]++;
                  });
                  return acc;
                },
                { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 }
              );

            return {
              ...team,
              node: {
                ...team.node,
                activeAthletes,
                leadsCount,
                reconnectLeadsCount,
                maxAthletes,
                swimmerCounts, // ✅ CORRECTED HERE
              },
              availableSpots: maxAthletes - activeAthletes.length,
              maleVsFemale: `${maleCount} / ${femaleCount}`,
            };
          });
        }

        return this.clubInfo.edges[0].node.team.edges;
      }
      return [];
    },

    filteredGroupData() {
      // If "Show All" is selected, return all teams.
      if (this.competitiveFilter === "all") {
        return this.groupData;
      }

      // Determine the filter value based on the selected competitiveFilter
      const isCompetitive = this.competitiveFilter === "competitive";

      // Filter teams based on the competitiveFlag
      return this.groupData.filter((team) => {
        if (isCompetitive) {
          return team.node.competitiveFlag === 1; // Only competitive teams
        } else {
          return (
            team.node.competitiveFlag === 0 ||
            team.node.competitiveFlag === null
          ); // Only non-competitive teams
        }
      });
    },
    totalActiveAthletes() {
      return this.filteredGroupData
        .filter(
          (team) => !team.node.teamName.includes("TRYOUT", "Inactive", "ALL")
        )
        .reduce((sum, team) => sum + team.node.activeAthletes.length, 0);
    },
    totalMaxAthletes() {
      return this.filteredGroupData.reduce(
        (sum, team) => sum + team.node.maxAthletes,
        0
      );
    },
    totalLeads() {
      return this.filteredGroupData.reduce(
        (sum, team) => sum + team.node.leadsCount,
        0
      );
    },
    totalReconnectLeads() {
      return this.filteredGroupData.reduce(
        (sum, team) => sum + team.node.reconnectLeadsCount,
        0
      );
    },
    totalMalevsFemale() {
      let totalMale = 0;
      let totalFemale = 0;

      this.filteredGroupData.forEach((team) => {
        const activeAthletes = team.node.activeAthletes;

        totalMale += activeAthletes.filter(
          (athlete) => athlete.node.gender === "male"
        ).length;

        totalFemale += activeAthletes.filter(
          (athlete) => athlete.node.gender === "female"
        ).length;
      });

      return `${totalMale}/${totalFemale}`;
    },
    clubInfoNew() {
      return this.clubInfo.edges.filter(
        (item) => item.node.clubId == this.$route.params.club
      );
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    getSubTableHeaders(swimmerCounts) {
      console.log(swimmerCounts);
      return Object.entries(swimmerCounts)
        .filter(([_, count]) => count > 0) // Remove empty days
        .map(([day]) => ({ text: day, value: day }));
    },

    // Toggle the selection state for a team ID
    toggleSelection(teamId) {
      if (this.selectedTeams.includes(teamId)) {
        this.selectedTeams = this.selectedTeams.filter((id) => id !== teamId);
      } else {
        this.selectedTeams.push(teamId);
      }
    },
    // Check if a team is selected
    isSelected(teamId) {
      return this.selectedTeams.includes(teamId);
    },
    filterGroupData() {
      console.log(`Filtering by: ${this.competitiveFilter}`);
    },
    // Opens the Athlete List page in a new tab with the desired statuses and team name
    goToAthletes(clubId, teamName, statuses) {
      console.log(
        `Navigating to athlete_list for team: ${teamName} with statuses: ${statuses}`
      );

      const routeData = this.$router.resolve({
        path: `/${clubId}/club/athlete_list`,
        query: {
          tab: "dataTable",
          subTab: teamName,
          status: statuses,
        },
      });
      // Open in a new tab
      window.open(routeData.href, "_blank");
    },

    goToTeam(clubId, teamName) {
      const statuses = [
        "active",
        "deposit",
        "tryout",
        "qualified",
        "confirmed",
      ];
      console.log(
        `Navigating to athlete_list for team: ${teamName} and clubId: ${clubId}`
      );

      const routeData = this.$router.resolve({
        path: `/${clubId}/club/athlete_list`,
        query: {
          tab: "dataTable",
          subTab: teamName,
          //status: statuses,
        },
      });
      // Open in a new tab
      window.open(routeData.href, "_blank");
    },
    truncateText(text, length = 50) {
      if (!text) return "";
      return text.length > length ? text.substring(0, length) + "..." : text;
    },
    printPage() {
      // Accessing the window object directly
      window.print(); // This triggers the print dialog
    },
    getItemClass(item) {
      return item.node.teamName === "Total" ? "total-row" : "";
    },
    sendGroupEmail() {
      const selectedTeamEmails = [];
      const selectedTeamNames = [];

      // Collect emails and names for each selected team
      this.filteredGroupData.forEach((team) => {
        if (this.selectedTeams.includes(team.node.teamId)) {
          // Collect team name
          selectedTeamNames.push(team.node.teamName);

          // Collect emails for active athletes with valid email addresses
          const emails = team.node.athlete.edges
            .filter(
              (athlete) =>
                athlete.node.status === "active" && athlete.node.email
            )
            .map((athlete) => athlete.node.email);
          selectedTeamEmails.push(...emails);
        }
      });

      if (!selectedTeamEmails.length) {
        alert(
          "No active athletes with valid email addresses in the selected teams."
        );
        return;
      }

      // Unique emails to avoid duplicates
      const uniqueEmails = [...new Set(selectedTeamEmails)];

      // Format selected team names as a list for the email body
      const teamList = selectedTeamNames.join(", ");
      const clubName = this.clubInfoNew[0].node.clubName;
      const subject = encodeURIComponent(
        `Announcement for ${teamList} Teams from Club ${clubName}`
      );
      const body = encodeURIComponent(
        `Hello Teams,\n\n` +
          `If you got this email, you are part of ${clubName} communication for selected teams: ${teamList}.\n\n` +
          `We would like to inform you about upcoming events.\n\n` +
          `1. Training Schedule: Updated for next month\n` +
          `2. Fees: Please ensure payments are up-to-date\n` +
          `3. Tournament: Confirm your participation by Friday\n\n` +
          `Best Regards,\n` +
          `RocketSwim Management`
      );

      // Create the mailto link with all emails and formatted subject and body
      const mailtoLink = `mailto:?bcc=${uniqueEmails.join(";")}
      &subject=${subject}&body=${body}`;

      window.location.href = mailtoLink;
    },

    sportTypeList: function () {
      return this.categoryValue.edges
        .filter((category) => category.node.category)
        .filter((category) => category.node.category.catName == "SPORT_TYPE");
    },
    handleGetClubInfo() {
      //reach out of Vuex store, fire action that gets athletes
      this.$store.dispatch("allAthlete", {
        clubId: this.$route.params.club,
      });
    },
    GroupMutate() {
      // console.log("Team", this.editedItem);
      //console.log("Initiating GroupMutate..."); // Track when the function is triggered
      //console.log("Edited Item Data:", this.editedItem); // Log data being sent
      this.$store.dispatch("groupMerge", {
        teamId: this.editedItem.teamId,
        teamName: this.editedItem.teamName,
        year: this.editedItem.year.substring(0, 4),
        toYear: this.editedItem.toYear,
        clubId: this.$route.params.club,
        visibility: 1, // this.editedItem.visibility,
        orderOnUi: this.editedItem.orderOnUi ? this.editedItem.orderOnUi : 100,
        sportType: this.editedItem.sportType,
        logo: this.editedItem.logo,
        maxAthletes: this.editedItem.maxAthletes,
        competitiveFlag: this.editedItem.competitiveFlag,
        studentCoachRatio: this.editedItem.studentCoachRatio,
        monthlyFee: this.editedItem.monthlyFee,
        registrationFee: this.editedItem.registrationFee,
        fundrasingFee: this.editedItem.fundrasingFee,
        coaches: this.editedItem.coaches,
        teamDescription: this.editedItem.teamDescription,
        commitmentRequirements: this.editedItem.commitmentRequirements,
        updateSource: "VueJS tst",
      });
    },
    GroupDelete() {
      this.$store.dispatch("groupDelete", {
        clubId: this.$route.params.club,
        teamId: this.editedItem.teamId,
      });
      this.editedItem = {};
    },
    editItem(item) {
      this.editedIndex = this.clubInfo.edges[0].node.team.edges.findIndex(
        (x) => x.node === item
      );
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.handleGetClubInfo.toString().indexOf(item);
      this.editedItem = Object.assign({}, item);
      confirm("Are you sure you want to delete this item?") &&
        // this.handleGetClubInfo.splice(index, 1);
        this.GroupDelete(index);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      this.GroupMutate();
      this.close();
    },
    isAdmin() {
      return this.user && this.user.role == "Administrator";
    },
  },
  mounted() {
    console.log(this.user);
    console.log(this.sortedGroupData);
  },
};
</script>
<style scoped>
.total-row {
  font-weight: bold;
  background-color: #f0f0f0;
}
.team-link {
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
}
.team-link:hover {
  color: #1565c0;
}
/* Flex container to align checkbox and icons inline */
.action-container {
  display: flex;
  align-items: center;
}

/* Make checkbox smaller */
.small-checkbox {
  transform: scale(0.65); /* Scale down the checkbox */
  margin-top: 0; /* Add a small margin to align with icons */
}
</style>
